import React, { useState } from 'react'
import { ThrashIcon } from '@mote/assets/icons'
import type { MoteActionButtonProps } from '../MoteActionButton'
import { MoteActionButton } from '../MoteActionButton'
import { MoteDeleteConfirmationDialog } from './MoteDeleteConfrimationDialog'

export interface MoteDownloadButtonProps
  extends Pick<MoteActionButtonProps, 'textPosition'> {
  onDelete: () => void
  loading?: boolean
}

export function MoteDeleteButton(props: MoteDownloadButtonProps) {
  const [isOpen, setIsOpen] = useState(false)

  async function handleClick() {
    setIsOpen(true)
  }

  return (
    <>
      <MoteActionButton
        onClick={handleClick}
        size={'sm'}
        text={'Delete'}
        icon={<ThrashIcon />}
        id={'delete-mote-button'}
        ariaLabel={'Delete'}
        textPosition={props.textPosition}
      />
      {isOpen ? (
        <MoteDeleteConfirmationDialog
          loading={props.loading}
          onConfirm={async () => {
            await props.onDelete()
            setIsOpen(false)
          }}
          onClose={() => setIsOpen(false)}
        />
      ) : null}
    </>
  )
}
